import { combineReducers } from 'redux'
import commonReducer, { commonActions } from '@app-store/slices/ui/common.slice'
import authSliderReducer, { authSliderActions } from '@app-store/slices/ui/authSlider.slice'
import emailCampaignReducer, { emailCampaignActions } from '@app-store/slices/ui/eventEmailCampaign'
import settingsReducer, { settingsActions } from '@app-store/slices/ui/settings.slice'
import meetingRequestReducer, { meetingRequestActions } from '@app-store/slices/ui/meetingRequest.slice'
import itpReducer, { itpActions } from '@app-store/slices/ui/itp.slice'
import selectMatchListReducer, { selectMatchListActions } from '@app-store/slices/ui/selectMatchList.slice'
import companyProfileReducer, { companyProfileActions } from '@app-store/slices/ui/companyProfile.slice'
import wishListReducer, { wishListActions } from '@app-store/slices/ui/wishlist.slice'
import directoryReducer, { directoryActions } from '@app-store/slices/ui/directory.slice'
import productReducer, { productActions } from '@app-store/slices/ui/product.slice'
import serviceReducer, { serviceActions } from '@app-store/slices/ui/service.slice'
import chatReducer, { chatActions } from '@app-store/slices/ui/chat.slice'
import wishCampaignReducer, { wishCampaignActions } from '@app-store/slices/ui/wishCampaign.slice'
import outgoingMeetingRequestsReducer, {
    outgoingMeetingRequestsActions
} from '@app-store/slices/ui/outgoingMeetingRequests.slice'
import userReducer, { userActions } from '@app-store/slices/ui/user.slice'
import contactReducer, { contactActions } from '@app-store/slices/ui/contact.slice'
import momentumReducer, { momentumActions } from '@app-store/slices/ui/momentum.slice'
import surveyReducer, { surveyActions } from '@app-store/slices/ui/survey.slice'
import crmIntegrationReducer, { crmIntegrationActions } from '@app-store/slices/ui/crmIntegration.slice'
import matchesByTokenReducer, { matchesByTokenActions } from '@app-store/slices/ui/matchesByToken.slice'
import scansReducer, { scansActions } from '@app-store/slices/ui/scans.slice'
import incomingMeetingRequestsReducer, {
    incomingMeetingRequestsActions
} from '@app-store/slices/ui/incomingMeetingRequests.slice'
import subscriptionReducer, { subscriptionActions } from '@app-store/slices/ui/subscription.slice'
import groupsReducer, { groupsActions } from '@app-store/slices/ui/groups.slice'
import authDynamicReducers, { authDynamicActions } from './authDynamic'
import matchListViewReducer, { matchListViewActions } from './matchListView.slice'
import matchListResponsesReducer, { matchListResponsesActions } from './matchListResponses.slice'
import matchListMeetingsReducer, { matchListMeetingsActions } from './matchListMeetings.slice'
import matchListsReducer, { matchListsActions } from './matchLists.slice'
import sharedListResponsesReducer, { sharedListResponsesActions } from './sharedListResponses.slice'
import meetingWishListsReducer, { meetingWishListsActions } from './meetingWishLists.slice'
import meetingAgendaReducer, { meetingAgendaActions } from './meetingAgenda.slice'
import myAgendaReducer, { myAgendaActions } from './myAgenda.slice'
import companyMeetingsReducer, { companyMeetingsActions } from './companyMeetings.slice'
import companyIncomingRequestsReducer, { companyIncomingRequestsActions } from './companyIncomingRequests.slice'
import companyOutgoingRequestsReducer, { companyOutgoingRequestsActions } from './companyOutgoingRequests.slice'
import localizationReducer, { localizationActions } from './localization.slice'
import usersReducer, { usersActions } from './users.slice'
import hallReducer, { hallActions } from '@app-store/slices/ui/hall.slice'
import badgeReducer, { badgeActions } from './badge.slice'
import companyStatisticsReducer, { companyStatisticsActions } from './companyStatistics.slice'
import templatesReducer, { templatesActions } from './templates.slice'
import unassignedCompaniesListReducer, { unassignedCompaniesListActions } from './unassignedCompanies.slice'
import unassignedContactsListReducer, { unassignedContactsListActions } from './unassignedContacts.slice'
import publishedCompaniesListReducer, { publishedCompaniesListActions } from './publishedCompanies.slice'
import publishedContactsListReducer, { publishedContactsListActions } from './publishedContacts.slice'
import assignedCompaniesListReducer, { assignedCompaniesListActions } from './assignedCompanies.slice'
import assignedContactsListReducer, { assignedContactsListActions } from './assignedContacts.slice'
import editListReducer, { editListActions } from './editList.slice'
import generalReducer, { generalActions } from './general.slice'
import rfqsReducer, { rfqsActions } from './rfqs.slice'
import quotationsReducer, { quotationsActions } from './quotations.slice'
import sendQuoteReducer, { sendQuoteActions } from './sendQuote.slice'
import incomingRfqsReducer, { incomingRfqsActions } from './incomingRfqs.slice'
import outgoingRfqsReducer, { outgoingRfqsActions } from './outgoingRfqs.slice'
import incomingQuotationsReducer, { incomingQuotationsActions } from './incomingQuotations.slice'
import outgoingQuotationsReducer, { outgoingQuotationsActions } from './outgoingQuotations.slice'
import companySubscriptionsReducer, { companySubscriptionsActions } from './companySubscriptions.slice'
import ordersReducer, { ordersActions } from './orders.slice'
import demosReducer, { demoActions } from './demos.slice'
import otpLoginReducer, { otpLoginActions } from './otpLogin.slice'
import transactionsReducer, { transactionsActions } from './transactions.slice'
import auditTrailReportingReducer, { auditTrailReportingActions } from './auditTrailReporting.slice'
import analyticsReducer, { analyticsActions } from '@app-store/slices/ui/analytics.slice'

export const uiReducer = combineReducers({
    authSlider: authSliderReducer,
    authDynamic: authDynamicReducers,
    common: commonReducer,
    emailCampaign: emailCampaignReducer,
    settings: settingsReducer,
    meetingRequest: meetingRequestReducer,
    directory: directoryReducer,
    products: productReducer,
    services: serviceReducer,
    chat: chatReducer,
    outgoingMeetingRequests: outgoingMeetingRequestsReducer,
    companyProfile: companyProfileReducer,
    wishCampaign: wishCampaignReducer,
    wishList: wishListReducer,
    itp: itpReducer,
    user: userReducer,
    contact: contactReducer,
    momentum: momentumReducer,
    survey: surveyReducer,
    crmIntegration: crmIntegrationReducer,
    selectMatchList: selectMatchListReducer,
    matchesByToken: matchesByTokenReducer,
    scans: scansReducer,
    incomingMeetingRequests: incomingMeetingRequestsReducer,
    subscription: subscriptionReducer,
    groups: groupsReducer,
    matchListView: matchListViewReducer,
    matchListResponses: matchListResponsesReducer,
    matchListMeetings: matchListMeetingsReducer,
    matchLists: matchListsReducer,
    sharedListResponses: sharedListResponsesReducer,
    meetingWishLists: meetingWishListsReducer,
    meetingAgenda: meetingAgendaReducer,
    myAgenda: myAgendaReducer,
    companyMeetings: companyMeetingsReducer,
    companyIncomingRequests: companyIncomingRequestsReducer,
    companyOutgoingRequests: companyOutgoingRequestsReducer,
    localization: localizationReducer,
    users: usersReducer,
    hall: hallReducer,
    badges: badgeReducer,
    companyStatistics: companyStatisticsReducer,
    templates: templatesReducer,
    unassignedCompanies: unassignedCompaniesListReducer,
    unassignedContacts: unassignedContactsListReducer,
    publishedCompanies: publishedCompaniesListReducer,
    publishedContacts: publishedContactsListReducer,
    assignedCompanies: assignedCompaniesListReducer,
    assignedContacts: assignedContactsListReducer,
    editList: editListReducer,
    general: generalReducer,
    rfqs: rfqsReducer,
    quotations: quotationsReducer,
    sendQuote: sendQuoteReducer,
    incomingRfqs: incomingRfqsReducer,
    outgoingRfqs: outgoingRfqsReducer,
    incomingQuotations: incomingQuotationsReducer,
    outgoingQuotations: outgoingQuotationsReducer,
    companySubscriptions: companySubscriptionsReducer,
    demos: demosReducer,
    orders: ordersReducer,
    otpLogin: otpLoginReducer,
    transactions: transactionsReducer,
    auditTrailReporting: auditTrailReportingReducer,
    analytics: analyticsReducer
})

export const uiActions = {
    common: commonActions,
    authSlider: authSliderActions,
    authDynamic: authDynamicActions,
    directory: directoryActions,
    products: productActions,
    services: serviceActions,
    chat: chatActions,
    emailCampaign: emailCampaignActions,
    settings: settingsActions,
    meetingRequest: meetingRequestActions,
    outgoingMeetingRequests: outgoingMeetingRequestsActions,
    companyProfile: companyProfileActions,
    wishList: wishListActions,
    wishCampaign: wishCampaignActions,
    itp: itpActions,
    user: userActions,
    contact: contactActions,
    momentum: momentumActions,
    survey: surveyActions,
    crmIntegration: crmIntegrationActions,
    selectMatchList: selectMatchListActions,
    matchesByToken: matchesByTokenActions,
    scans: scansActions,
    incomingMeetingRequests: incomingMeetingRequestsActions,
    subscription: subscriptionActions,
    groups: groupsActions,
    matchListView: matchListViewActions,
    matchListResponses: matchListResponsesActions,
    matchListMeetings: matchListMeetingsActions,
    matchLists: matchListsActions,
    sharedListResponses: sharedListResponsesActions,
    meetingWishLists: meetingWishListsActions,
    meetingAgenda: meetingAgendaActions,
    myAgenda: myAgendaActions,
    companyMeetings: companyMeetingsActions,
    companyIncomingRequests: companyIncomingRequestsActions,
    companyOutgoingRequests: companyOutgoingRequestsActions,
    localization: localizationActions,
    users: usersActions,
    hall: hallActions,
    badges: badgeActions,
    companyStatistics: companyStatisticsActions,
    templates: templatesActions,
    unassignedCompanies: unassignedCompaniesListActions,
    unassignedContacts: unassignedContactsListActions,
    publishedCompanies: publishedCompaniesListActions,
    publishedContacts: publishedContactsListActions,
    assignedCompanies: assignedCompaniesListActions,
    assignedContacts: assignedContactsListActions,
    editList: editListActions,
    general: generalActions,
    rfqs: rfqsActions,
    quotations: quotationsActions,
    sendQuote: sendQuoteActions,
    incomingRfqs: incomingRfqsActions,
    outgoingRfqs: outgoingRfqsActions,
    incomingQuotations: incomingQuotationsActions,
    outgoingQuotations: outgoingQuotationsActions,
    companySubscriptions: companySubscriptionsActions,
    demos: demoActions,
    orders: ordersActions,
    otpLogin: otpLoginActions,
    transactions: transactionsActions,
    auditTrailReporting: auditTrailReportingActions,
    analytics: analyticsActions
}
